import { render, staticRenderFns } from "./CRMarketInsights.vue?vue&type=template&id=f5ae4a78"
import script from "./CRMarketInsights.vue?vue&type=script&lang=js"
export * from "./CRMarketInsights.vue?vue&type=script&lang=js"
import style0 from "./CRMarketInsights.vue?vue&type=style&index=0&id=f5ae4a78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports